import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DateInput, NumberInput } from "components/table/carousel/inputs"
import NoneStateTrashIcon from "components/table/carousel/none-state-trash-icon"
import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { checkDateMode } from "data/lib/dates"
import { field_attrs } from "components/table/lib/column-field"

const VacantLeaseupBasic = (props: {rowData: [], field: string, namedItems: {}, persist: Function}) => {
  const emptyRecord = {
    beginDate: null,
    leaseupMos: null
  }
  const [data, setData] = useState<object|null>(props.rowData[props.field]);

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val
    if (field === 'beginDate') {
      let dateMode = checkDateMode(val);
      nextData['dateMode'] = dateMode;
    }
    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'vacantleaseupdetail', props.rowData)
  }

  const attrs = (field) => field_attrs('multifamily', props.field)(field)(props.rowData, props)

  return (
    <div>
      <NoneStateTrashIcon />
      <SingleRowCarouselState_s>
        <div>
          <label>Begin Date</label>
          <DateInput className="automated" data={data} attrs={attrs} field="beginDate" persist={updateData} allowRelative withoutDays />
        </div>
        <div>
          <label>Leaseup Mos</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="leaseupMos" persist={updateData} readPrecision={2} writePrecision={2} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default VacantLeaseupBasic